import { motion } from 'motion/react';
import { Clock, Shield, Award, X } from 'lucide-react';
import { useState } from 'react';
//import asbjornImage from '/assets/images/personalityTest/d634c6062972a6a8fc7008224fe3b36ce2af2f6a.png';

interface IntroScreenProps {
  onStart: () => void;
}

export function IntroScreen({ onStart }: IntroScreenProps) {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex flex-col items-center justify-center p-6 pb-12"
    >
      <div className="w-full max-w-md space-y-8">
        {/* Asbjørn Icon */}
        {/* <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="flex justify-center mb-8"
        >
          <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center" style={{ boxShadow: 'var(--shadow-soft)' }}>
            <img src="/assets/images/personalityTest/d634c6062972a6a8fc7008224fe3b36ce2af2f6a.png" alt="Asbjørn" className="w-full h-full rounded-full object-cover" />
          </div>
        </motion.div> */}

        {/* Title */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-center space-y-3 pt-8"
        >
          <h1 className="text-gray-900">Hvilken type er du?</h1>
          {/* <p className="text-gray-600 font-bold text-[20px] font-[ITC_Avant_Garde_Gothic_Std]">Uanset hvilken Asbjørn du er</p> */}
        </motion.div>

        {/* Copy */}
        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-center text-gray-600"
        >
          Tag testen og få en personlig anbefaling, der passer til din type og dit arbejdsliv.
        </motion.p>

        {/* Info Card */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="bg-white rounded-3xl p-6 space-y-4"
          style={{ boxShadow: 'var(--shadow-soft)' }}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-bg-soft flex items-center justify-center mt-5">
              <Clock className="w-5 h-5 text-ase-petroleum" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-gray-900">7 spørgsmål</p>
              <p className="text-gray-500">Varighed: ca. 1 min.</p>
            </div>
          </div>

          <div className="border-t border-gray-100 pt-4 space-y-3 bg-[#f2f9f9] -mx-6 px-6 -mb-6 pb-6 rounded-b-3xl">
            <div className="flex gap-3">
              <Shield className="w-5 h-5 text-ase-petroleum flex-shrink-0 mt-0.5" strokeWidth={1.5} />
              <p className="text-gray-600">Vi gemmer ikke dine svar</p>
            </div>
            <div className="flex gap-3">
              <Award className="w-5 h-5 text-ase-petroleum flex-shrink-0 mt-0.5" strokeWidth={1.5} />
              <p className="text-gray-600">Der er ingen rigtige eller forkerte svar</p>
            </div>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.button
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
          onClick={onStart}
          className="btn button w-full bg-ase-orange text-white py-4 px-6 transition-all active:scale-95"
          style={{ boxShadow: 'var(--shadow-soft)' }}
        >
          Start nu
        </motion.button>

        {/* Secondary Link */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="text-center"
        >
          <button className="text-ase-petroleum personalitytest" onClick={() => setShowInfo(true)}>
            Om testen
          </button>
        </motion.div>
      </div>

      {/* Info Popup */}
      {showInfo && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 z-40"
            onClick={() => setShowInfo(false)}
          />
          
          {/* Popup */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="fixed inset-x-4 top-1/2 -translate-y-1/2 max-w-md mx-auto bg-white rounded-3xl p-6 z-50"
            style={{ boxShadow: 'var(--shadow-lift)' }}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowInfo(false)}
              className="absolute top-4 right-4 w-10 h-10 rounded-full bg-bg-soft flex items-center justify-center transition-all active:scale-95 hover:bg-gray-200 personalitytest"
            >
              <X className="w-5 h-5 text-gray-600" strokeWidth={1.5} />
            </button>

            {/* Content */}
            <div className="space-y-4 pr-8">
              <h2 className="text-gray-900">Om testen</h2>
              
              <div className="space-y-3 text-gray-600">
                <p>
                  Testen er udviklet af Ase for at hjælpe dig med at finde den dækning, der passer bedst til dine behov.
                </p>
                <p>
                  Vi gemmer ingen personlige data fra testen. Udfaldet af testen er kun en anbefaling.
                </p>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </motion.div>
  );
}